import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useEffect, useState } from "react";

const Review = () => {
  const reviewList = [
    {
      src: "/images/review1.png",
      txt: `<sapn>
      쓰레기집청소 요청드렸는데<br/>
쓰레기로 가득 찼던 집이<br/>
이렇게 바뀌다니 정말 놀랍네요...<br/>
아주 만족스럽습니다.
      </sapn>`,
    },
    {
      src: "/images/review2.png",
      txt: `
      <sapn>
      어머님집을 정리하는데<br/>
혼자 해보려다 답이 나오질 않아<br/>
도움을 요청드렸는데요<br/>
깔끔하게 잘 해주셨어요
      </sapn>`,
    },
    {
      src: "/images/review3.png",
      txt: `<sapn>
      유품정리 업체 찾아보다가<br/>
연락을 드렸는데 너무 잘해주셔서<br/>
다른곳에 소개도 해드렸답니다.<br/>
정말 정말 감사합니다 ~ ^^
      </sapn>
      `,
    },
    {
      src: "/images/review4.png",
      txt: `
      <span>
      시골에 안사용하는 집을<br/>
처분하게되어 정리를 요청드렸는데<br/>
처음엔 반신반의했다가<br/>
작업완료 사진 보고 만족했습니다.
      </span>`,
    },
    {
      src: "/images/review5.png",
      txt: `
      <span>
      고독사 특수청소 요청드렸는데<br/>
바닥 장판까지 싹 뜯어서<br/>
잘해주셨더라구요<br/>
아주 만족스럽습니다.
      </span>`,
    },
    {
      src: "/images/review6.png",
      txt: `
      <span>
      엘리베이터가 없어 힘드셨을텐데<br/>
불평불만 한번도 안하시고<br/>
엄청 친절하게 해주셔서<br/>
감사한 마음에 리뷰를 달았습니다
      </span>`,
    },
    {
      src: "/images/review7.png",
      txt: `
      <span>
      세입자가 잠수타는 바람에 급하게<br/>
요청을 드렸는데<br/>
이런문의를 자주 받아보셨는지<br/>
깔끔하게 안내해주시더라구요
      </span>`,
    },
    {
      src: "/images/review8.png",
      txt: `
      <span>
      정리 전 사진과 마감 후 사진을<br/>
끝나고 다 보내주시고<br/>
귀중품도 다 한자리에 잘 놔주셔서<br/>
되게 만족스러웠습니다
      </span>`,
    },
    {
      src: "/images/review9.png",
      txt: `<span>
      배달음식이랑 쓰레기들이<br/>
진짜 엄청 많았는데....<br/>
완전 다른집이 된 것 같아서 너무 좋아요<br/>
감사합니다.
      </span>`,
    },
    {
      src: "/images/review10.png",
      txt: `<span>
      생활에 사용하던 가전용품들을<br/>
견적가에서 바로 빼주시더라구요!<br/>
덕분에 가전제품 처리도 한번에 하고<br/>
견적도 싸게해서 좋았습니다.
      </span>`,
    },
  ];

  const [count, setCount] = useState(5);

  useEffect(() => {
    if (window.innerWidth > 800) {
      setCount(5);
    } else {
      setCount(1);
    }

    window.addEventListener("resize", () => {
      if (window.innerWidth > 800) {
        setCount(5);
      } else {
        setCount(1);
      }
    });

    return () => {
      window.removeEventListener("resize", () => {
        if (window.innerWidth > 800) {
          setCount(5);
        } else {
          setCount(1);
        }
      });
    };
  }, []);

  useEffect(() => {});
  return (
    <div id="review" className="relative w-full h-full py-14 lg:py-28 xl:pb-36">
      <div
        id="title"
        className="relative w-full h-fit text-center mb-10 xl:mb-20"
      >
        <div className="relative w-fit h-full mx-auto text-black">
          <h3 className="font-normal">
            <span className="text-black">집치워드림&nbsp;센터&nbsp;</span>
            <span className="bg-secondary text-white px-1 pt-1">
              고객 REVIEW
            </span>
          </h3>
        </div>
        <p className="my-3 lg:text-lg text-primary">
          -&nbsp;REAL&nbsp;REVIEW&nbsp;-
        </p>
        <p className=" mt-5 text-xl manru font-black ">·&nbsp;·&nbsp;·</p>
      </div>
      <Swiper
        spaceBetween={30}
        // centeredSlides={true}
        loop={true}
        slidesPerView={count}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        className=" relative w-full h-full mx-auto grid"
      >
        {reviewList.map((v, i) => (
          <SwiperSlide
            key={i}
            className=" relative w-full h-full min-w-72 px-5 lg:px-0 "
          >
            <div className=" relative w-full h-full py-5">
              <div className="relative w-full h-10 max-w-44 mx-auto mb-2 animate-bounce ">
                <img
                  src="/images/iconStar.png"
                  alt="집치워드림센터 고객 별점 5점 후기"
                  className=" relative w-full h-fit object-contain"
                />
              </div>
              <div className="relative w-full h-[calc(100%-40px)] min-h-72 p-3 rounded-2xl bg-white border shadow-md">
                <img
                  className="relative w-full h-auto object-cover object-center rounded-3xl"
                  src={v.src}
                  alt={`집치워드림센터 고객 실제 후기 ${i + 1}`}
                />
                <div className=" relative w-full h-fit text-center pt-5">
                  <p
                    className="text-black"
                    dangerouslySetInnerHTML={{ __html: v.txt }}
                  ></p>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Review;
